module.exports = __webpack_public_path__ + "img/search-ico.24d58443.svg";